import { Component } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'enova-loading',
  standalone: true,
  imports: [MatProgressSpinnerModule],
  templateUrl: './enova-loading.component.html',
  styleUrl: './enova-loading.component.scss',
})
export class EnovaLoadingComponent {}
